import type { FunnelStep } from "schemas/generated/funnelStep";

export const generateNodesCanvas = (
  funnelSteps: FunnelStep[],
  projectId: string,
) => {
  const nodes = funnelSteps.map((step, index) => {
    return {
      id: step.id,
      data: {
        path: step.file?.path ?? "",
        name: step.file?.name ?? "",
        projectId,
        pageId: step.file?.id ?? "",
      },
      position: { x: index * 350, y: 0 },
      type: "page-canvas",
    };
  });

  return nodes;
};
